// extracted by mini-css-extract-plugin
export var base = "_1w-0";
export var updateBanner = "_1w-1";